export enum LOCAL_STORAGE_KEYS {
    ACTIVE_ROLE = 'activeRole',
    APPLICATION_PERMISSIONS = 'applicationPermissions',
    BLOCK_PERMISSIONS = 'blockPermissions',
    DISTRICT_PERMISSIONS = 'districtPermissions',
    FONT_SIZE = 'fontSize',
    NATIONAL_PERMISSIONS = 'nationalPermissions',
    SELECTED_LANGUAGE = 'selectedLanguage',
    STATE_PERMISSIONS = 'statePermissions',
    SUB_ROLES = 'subRoles',
    THEME = 'theme',
    TOKEN = 'token',
    USER = 'user',
    USER_PROFILE = 'userProfile',
    USER_ROLES = 'userRoles',
}
